import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConversionDistanceService {
  public getBest = (millimeters: number): string | null => {
    if (!millimeters) return null;
    if (millimeters < 10) return `${millimeters} mm`;
    if (millimeters < 1000) return `${this.getCentimeters(millimeters)} cm`;
    if (millimeters < 1000000) return `${this.getMeters(millimeters)} m`;
    return `${this.getKm(millimeters)} km`;
  }

  private getConversion = (numerator: number, denominator: number): number => {
    const value = numerator / denominator
    return parseFloat(value?.toFixed(2));
  }

  private getCentimeters = (millimeters: number): number => this.getConversion(millimeters, 10);
  private getMeters = (millimeters: number): number => this.getConversion(millimeters, 1000);
  private getKm = (millimeters: number): number => this.getConversion(millimeters, 1000000);
}
